var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, CssBaseline } from '@mui/material';
import { RouterManager } from './modules/router/RouterManager';
import React, { useEffect, useMemo, useState } from 'react';
import { useWebgate } from '@xvia/webgate-connect';
import { CacheProvider } from '@emotion/react';
import { useUserInfoStore } from './util/UserInfoStore';
import ErrorBoundary from './components/ErrorBoundary';
import { ShowContent } from './components/ShowContent';
import { AuthApi } from './apis/authApi';
import { AuthUtil } from './util/auth-util';
import { jwtDecode } from 'jwt-decode';
import { DefaultContent } from './components/DefaultContent';
import { CookiesUtils } from './util/CookiesUtils';
import { AuthConstants } from './util/auth-constants';
export var App = function (_a) {
    //region Constants
    var cache = _a.cache;
    var setUserInfo = useUserInfoStore(function (state) { return state.setUserInfo; });
    var loggedUser = useUserInfoStore(function (state) { return state.userInfo; });
    var _b = useState(true), loadingUserInfo = _b[0], setLoadingUserInfo = _b[1];
    var _c = useState(false), loadingLogin = _c[0], setLoadingLogin = _c[1];
    var userInfo = useWebgate().userInfo;
    var initializeUserInfo = function () {
        setTimeout(function () { return setLoadingUserInfo(false); }, 1000);
    };
    //endregion
    //region Hooks
    var isLocalDevelopment = useMemo(function () {
        console.log('Dev: ' + AuthUtil.DEVELOPMENT_LOCAL);
        return AuthUtil.DEVELOPMENT_LOCAL === 'true';
    }, []);
    var invalid = useMemo(function () {
        if (!isLocalDevelopment) {
            return !userInfo;
        }
        return false;
    }, [userInfo, isLocalDevelopment]);
    useEffect(function () {
        if (userInfo) {
            setUserInfo(userInfo);
        }
        else {
            setUserInfo(null);
        }
        initializeUserInfo();
    }, [setUserInfo, userInfo]);
    useEffect(function () {
        if (!invalid) {
            verificarToken();
        }
    }, [invalid]);
    useEffect(function () {
        console.log("Usuário Logado.");
        console.log(loggedUser);
    }, [loggedUser]);
    //endregion
    //region Handles
    var handleLogin = function () { return __awaiter(void 0, void 0, Promise, function () {
        var request, mtLoginToken, cpf;
        var _a, _b;
        return __generator(this, function (_c) {
            if (!loadingLogin) {
                setLoadingLogin(true);
                request = void 0;
                if (isLocalDevelopment) {
                    request = AuthApi.tokenAdmin('admin', 'admin');
                }
                else {
                    mtLoginToken = (_a = CookiesUtils.get(AuthConstants.MT_CIDADAO_TOKEN.valueOf())) !== null && _a !== void 0 ? _a : '';
                    cpf = (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.cpf) !== null && _b !== void 0 ? _b : '';
                    request = AuthApi.tokenUserMtCidadao(cpf, mtLoginToken);
                }
                request.then(function (response) {
                    response.json().then(function (authToken) {
                        if (authToken['status'] >= 400) {
                            console.error('Erro: ' + authToken['message']);
                        }
                        else if (authToken === null || authToken === void 0 ? void 0 : authToken.access_token) {
                            AuthUtil.armazenarUserName(authToken.user_name);
                            AuthUtil.armazenarToken(authToken);
                            window.location.reload();
                        }
                    });
                })
                    .catch(function (error) {
                    console.error('Erro: ' + error);
                })
                    .finally(function () { return setLoadingLogin(false); });
            }
            return [2 /*return*/];
        });
    }); };
    var verificarToken = function () { return __awaiter(void 0, void 0, Promise, function () {
        var token, decoded, exp, expired;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = AuthUtil.getToken();
                    if (!!token) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleLogin()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    try {
                        decoded = jwtDecode(token);
                        exp = decoded.exp * 1000;
                        expired = exp < Date.now();
                        if (expired) {
                            AuthUtil.deletarToken();
                            handleLogin();
                        }
                    }
                    catch (error) {
                        console.error('Erro: ' + error);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    //endregion
    return (_jsxs(CacheProvider, __assign({ value: cache }, { children: [_jsx(CssBaseline, {}), _jsxs(DefaultContent, __assign({ loading: loadingUserInfo }, { children: [_jsx(ShowContent, __assign({ show: invalid }, { children: _jsx(Container, __assign({ maxWidth: "sm", sx: { mt: 4, mb: 4 } }, { children: _jsx(ErrorBoundary, { message: "Usu\u00E1rio n\u00E3o foi encontrado, para acessar essa p\u00E1gina voc\u00EA precisa realizar o login novamente." }) })) })), _jsx(ShowContent, __assign({ show: !invalid }, { children: _jsx(Box, __assign({ textAlign: 'center', sx: { paddingBottom: 4 } }, { children: _jsx(RouterManager, {}) })) }))] }))] })));
};
